type PayrollAccess = {
  hasAccess: boolean;
  canManage?: (key: string) => boolean;
};

type PayrollRecordsVisibilityAccess = {
  hasAccess: boolean;
  isVisible: boolean;
};

const SELF_SERVICE_ROLES = new Set(["employee", "intern"]);
const PAYROLL_RECORDS_DEFAULT_ROLES = new Set([
  "admin",
  "director",
  "founder",
  "hod",
  "hr",
  "hr admin",
  "hr head",
  "manager",
  "owner",
  "superadmin",
]);

export const canViewPayrollRecords = (
  role: string | null | undefined,
  access: PayrollRecordsVisibilityAccess,
): boolean => {
  if (PAYROLL_RECORDS_DEFAULT_ROLES.has((role || "").trim().toLowerCase())) {
    return !access.hasAccess || access.isVisible;
  }
  return access.hasAccess && access.isVisible;
};

export const canUsePayrollRecords = (
  role: string | null | undefined,
  access: PayrollAccess
): boolean => {
  const normalizedRole = (role || "").trim().toLowerCase();
  if (SELF_SERVICE_ROLES.has(normalizedRole)) return false;
  if (!access.hasAccess) return true;
  return access.canManage?.("payroll-records") === true;
};
